/**
 * Ink Bloom.
 *
 * A calm radial gradient expansion used on the first Your read reveal
 * in place of confetti. Reads like ink diffusing into paper, which
 * matches the Tactile Editorial brand voice. Confetti is a toy; ink
 * bloom feels like a profound insight.
 *
 * The bloom is a single DOM node with a radial-gradient background
 * that animates its scale and opacity over ~1.6 seconds, then removes
 * itself. Never blocks input and never emits sound.
 */
export function fireConfetti(target, options = {}) {
  const rect = target?.getBoundingClientRect?.() || { width: window.innerWidth, height: 320, left: 0, top: 0 };
  const hue = options.hue || "#1D5FD4"; // fallback: primary blue
  const wrap = document.createElement("div");
  wrap.setAttribute("data-testid", "ink-bloom");
  wrap.setAttribute("aria-hidden", "true");
  wrap.style.position = "fixed";
  wrap.style.left = rect.left + "px";
  wrap.style.top  = (rect.top || 0) + "px";
  wrap.style.width  = rect.width + "px";
  wrap.style.height = (rect.height || 320) + "px";
  wrap.style.pointerEvents = "none";
  wrap.style.overflow = "hidden";
  wrap.style.zIndex = "20";

  const bloom = document.createElement("div");
  bloom.style.position = "absolute";
  bloom.style.left = "50%";
  bloom.style.top  = "50%";
  bloom.style.width  = "40vmin";
  bloom.style.height = "40vmin";
  bloom.style.transform = "translate(-50%, -50%) scale(0.2)";
  bloom.style.background = `radial-gradient(closest-side, ${hue}55 0%, ${hue}22 45%, transparent 75%)`;
  bloom.style.filter = "blur(24px)";
  bloom.style.opacity = "0";
  bloom.style.transition = "opacity 240ms ease-out, transform 1400ms cubic-bezier(0.16, 1, 0.3, 1)";

  wrap.appendChild(bloom);
  document.body.appendChild(wrap);

  requestAnimationFrame(() => {
    bloom.style.opacity = "1";
    bloom.style.transform = "translate(-50%, -50%) scale(3.2)";
  });
  setTimeout(() => {
    bloom.style.opacity = "0";
  }, 1200);
  setTimeout(() => {
    wrap.remove();
  }, 1700);
}
